import React, { FC, useEffect, useState } from 'react'
import { useTryOpenViewStream } from 'features/viewerPage/hooks/useTryOpenViewStream'
import styles from './StreamOfflineView.module.scss'
import { Trans } from '@lingui/macro'

const POLL_INTERVAL_SECONDS = 30

export const StreamOfflineView: FC = () => {
  const tryOpenViewStream = useTryOpenViewStream()
  const [secondsLeft, setSecondsLeft] = useState(POLL_INTERVAL_SECONDS)
  const [attempts, setAttempts] = useState(1)
  const [lastCheckTime, setLastCheckTime] = useState(new Date())

  useEffect(() => {
    const poll = setInterval(() => {
      setAttempts((prev) => prev + 1)
      setLastCheckTime(new Date())
      setSecondsLeft(POLL_INTERVAL_SECONDS)
      tryOpenViewStream()
    }, POLL_INTERVAL_SECONDS * 1000)

    const countdown = setInterval(() => {
      setSecondsLeft((prev) => Math.max(0, prev - 1))
    }, 1000)

    return () => {
      clearInterval(poll)
      clearInterval(countdown)
    }
  }, [tryOpenViewStream])

  const progress =
    ((POLL_INTERVAL_SECONDS - secondsLeft) / POLL_INTERVAL_SECONDS) * 100

  const formatTime = (date: Date) =>
    date.toLocaleTimeString('en-US', { hour12: false })

  return (
    <div className={styles.Container}>
      <h1 className={styles.Title}>
        <Trans>Stream is offline</Trans>
      </h1>
      <p className={styles.Subtitle}>
        <Trans>Something went wrong with the stream connection.</Trans>
        <br />
        <Trans>We are on it — automatically checking every 30 seconds.</Trans>
      </p>

      <div className={styles.Card}>
        <p className={styles.NextCheck}>Next check in {secondsLeft} s</p>
        <div className={styles.ProgressBar}>
          <div
            className={styles.ProgressFill}
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className={styles.Stats}>
          <div className={styles.Stat}>
            <span className={styles.StatValue}>{attempts}</span>
            <span className={styles.StatLabel}>ATTEMPTS</span>
          </div>
          <div className={styles.StatDivider} />
          <div className={styles.Stat}>
            <span className={styles.StatValue}>
              {formatTime(lastCheckTime)}
            </span>
            <span className={styles.StatLabel}>LAST CHECK</span>
          </div>
          <div className={styles.StatDivider} />
          <div className={styles.Stat}>
            <span className={styles.StatValue}>Offline</span>
            <span className={styles.StatLabel}>STATUS</span>
          </div>
        </div>
      </div>

      <p className={styles.InfoMessage}>
        <span className={styles.InfoIcon}>ⓘ</span>
        <Trans>
          We will try to bring you the backup stream game, please give us a
          moment.
        </Trans>
      </p>

      <a
        href={process.env.REACT_APP_SUPPORT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.SupportLink}
      >
        Need more help? <strong>Contact support</strong>
      </a>
    </div>
  )
}
